import React, { useEffect, useState } from 'react';
import './App.css';
import "@fontsource/inter";
import CTSroutes from './components/routes/CTSroutes';
import { BrowserRouter, useNavigate } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './store';
import { ThemeContextProvider } from './context/ThemeContextProvider';
import loginService from './services/login.Service';

function AppContent() {
  const [showModal, setShowModal] = useState(false);
  const [pendingNavigation, setPendingNavigation] = useState(null);
  const navigate = useNavigate();

  // Safely parse login details from sessionStorage
  let user_id = null;
  let user_name = "User";
  let session_token = null;
  try {
    const login_details = sessionStorage.getItem("loginUser");
    if (login_details) {
      const userD = JSON.parse(login_details);
      user_name = userD?.result?.userInfo?.user_name || "User";
      user_id = userD?.result?.userInfo?.user_id;
      session_token = userD?.result?.authToken;
    }
  } catch (error) {
    console.error("Error parsing login details:", error);
  }

 
  const handleModalCancel = () => {
    setShowModal(false);
    setPendingNavigation(null);
  };

  return (
    <>
      <CTSroutes />
      {showModal && (
        <div className="modal">
          <div className="modal-content">
           <p>{user_name}, are you sure you want to leave? Your session will be logged out.</p>
            {/* <button onClick={handleModalConfirm}>Leave</button> */}
            <button onClick={handleModalCancel}>Cancel</button>
          </div>
        </div>
      )}
    </>
  );
}

function App() {
  return (
    <ThemeContextProvider>
      <BrowserRouter>
        <Provider store={store}>
          <AppContent />
        </Provider>
      </BrowserRouter>
    </ThemeContextProvider>
  );
}

export default App;